export function scrollYPercentage() {
    var h = typeof document !== 'undefined' ? document.documentElement : {}, b = typeof document !== 'undefined' ? document.body : {}, st = 'scrollTop', sh = 'scrollHeight';
    // @ts-ignore
    return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
}
